export default "__VITE_ASSET__ri5PU4tI__"